import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import ReactJson from 'react-json-view'
import {
  select_jobDetails,
  select_error,
  select_statusDetails,
  select_jobIdToCopy} from 'redux/jobs/selectors'
import {useAppDispatch} from 'redux/config'
import {
  Button,
  ErrorState,
  Icon,
  Spinner,
  Stack,
  Typography,
} from '@mdsol/onex-design'
import {fetchJobDetails, jobsAC} from 'redux/jobs/jobs.duck'
import {Status} from 'commonTypes'

const JobDetailsPanel: FC = () => {
  const dispatch = useAppDispatch()

  const job = useSelector(select_jobDetails)
  const status = useSelector(select_statusDetails)
  const error = useSelector(select_error)
  const jobIdDetails = useSelector(select_jobIdToCopy)

  const handleClose = () => {
    dispatch(jobsAC.hideJobDetails())
  }

  const handleRefreshDetails = () => {
    dispatch(fetchJobDetails(jobIdDetails))
  }

  return (
    <div className='row-details-panel'>
      <div className='header onex-data-grid-control'>
        <Typography variant='h4'>
          Job Details
        </Typography>

        <Button dataTestId='close-details-icon' onClick={handleClose} variant='secondary' buttonStyle='ghost' buttonType='icon'>
          <Icon>close</Icon>
        </Button>
      </div>

      <div className={`body onex-data-grid-control ${status === Status.PENDING ? 'with-spinner' : ''}`}>
        {status === Status.PENDING  && <Spinner dataTestId='job-details-spinner' size='lg' />}
        {job && status === Status.OK && (
          <ReactJson
            src={job}
            theme='rjv-default'
            iconStyle='circle'
            indentWidth={2}
            collapseStringsAfterLength={16}
            quotesOnKeys={false}
          />
        )
        }
        {status === Status.REJECTED && (
          <ErrorState
            buttonTitle='Try again'
            className='error-state-component-details'
            dataTestId='details-error-state'
            description={error?.message ?? 'Error occurred while loading job details.'}
            onClick={handleRefreshDetails}
            title='Server Error'
            defaultImgVariant='browser'
            variant='section'
            errorId={jobIdDetails}
          />)
        }
      </div>

      <div className='footer onex-data-grid-control'>
        <Stack direction='horizontal' gap={2}>
          <Button dataTestId='close-details-button' onClick={handleClose} size='md' variant='secondary'>
            Close
          </Button>
        </Stack>
      </div>
    </div>
  )
}

export default JobDetailsPanel
